// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8M0lj","right":"styles_right__1bMFU"};